import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getTransactionState = createSelector(
    (store: IStore) => store.transaction,
    store => store,
);
